/**
 * ChatHeader — top bar активной комнаты внутри ChatPanel: avatar, name,
 * online-индикатор / счётчик участников. Кнопка «назад» к списку комнат
 * скрывается на full-screen layout (`MessengerPage`).
 */

import { ArrowLeft } from 'lucide-react'
import { getInitials } from '../../../utils/chatHelpers'
import { getRoomIcon } from './internals'

export default function ChatHeader({ room, currentUserId, onBack, showBack = true }) {
    if (!room) return null
    const RoomIcon = getRoomIcon(room.type)
    // Only *other* participants count; comparing to room.id was wrong (room UUID ≠ user id),
    // so the current user’s own WS connection always made direct chats look «online».
    const self = currentUserId != null ? String(currentUserId) : null
    const online = room.participants?.some(
        p => p.is_online && (!self || String(p.user_id) !== self),
    )

    return (
        <div className="chat-header">
            {showBack ? (
                <button type="button" className="chat-header__back" onClick={onBack}>
                    <ArrowLeft size={18} />
                </button>
            ) : (
                <span className="chat-header__back-spacer" aria-hidden />
            )}
            <div className="chat-header__avatar">
                {RoomIcon ? <RoomIcon size={16} /> : getInitials(room.name)}
            </div>
            <div className="chat-header__info">
                <div className="chat-header__name">{room.name || 'Чат'}</div>
                <div className={`chat-header__status ${online ? 'chat-header__status--online' : ''}`}>
                    {room.type === 'direct' ? (
                        online ? 'В сети' : 'Не в сети'
                    ) : (
                        `${room.participant_count || 0} участников`
                    )}
                </div>
            </div>
        </div>
    )
}
